export enum ClockAction {
    'clockIn' = 1,
    'clockOut' = 2,
    'break' = 3
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/clock-in-out/shared/models/clock-action-enum.ts